import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { ProductPagedResponse } from "../_models/product.interface";
import { SharedService } from "@app/services/shared.service";

@Injectable({ providedIn: "root" })
export class ProductService extends SharedService {
  flashOfferSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  flashOffer$ = this.flashOfferSubject.asObservable();

  countSubject$ = new BehaviorSubject(0);
  count$ = this.countSubject$.asObservable();

  constructor(httpCLient: HttpClient) {
    super(httpCLient);
  }

  //https://localhost:5001/market/Product/Related

    ListProducts(payload:any) {
    const url = 'api/market/product/search';
    return this.post<ProductPagedResponse>(url, payload);
  }

   GetProductDetail(payload:any) {
    const url = 'api/market/product/details';
    return this.post<any>(url, payload);
  }

 /* ListProducts(payload: any) {
    const url = "https://localhost:5001/market/product/search";
    return this.postFake<ProductPagedResponse>(url, payload);
  }
  GetProductDetail(payload: any) {
    const url = "https://localhost:5001/market/product/details";
    return this.postFake<any>(url, payload);
  }
 */
  GetRelatedProducts(payload: any) {
    const url = "api/market/product/related";
    return this.post<any>(url, payload);
  }
}
